import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { isCrossingPageRoot, navigateToPage } from '@sorrem-client/ui/shared/app-navigation';

export interface AppNavigateProps {
    to: string;
    replace?: boolean;
}

/**
 * A render-time redirect, like the router's `<Navigate>`, that loads the
 * target fresh when it is another page (see app-navigation.ts).
 */
export function AppNavigate({ to, replace = false }: AppNavigateProps): JSX.Element | null {
    const isCrossPage = isCrossingPageRoot(window.location.pathname, to);

    useEffect(() => {
        if (isCrossPage) {
            navigateToPage(to, { replace });
        }
    }, [isCrossPage, replace, to]);

    return isCrossPage ? null : <Navigate to={to} replace={replace} />;
}
